import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './OrderConfirmationPage.css';
import checked from './checked.gif';
import Preloader from '../common/preloader';

const OrderConfirmation = () => {
  const { state } = useLocation();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showGif, setShowGif] = useState(false); // show gif only when valid

  useEffect(() => {
    window.scrollTo(0, 0);

    const timer = setTimeout(() => {
      if (state?.orderDetails) {
        setOrder(state.orderDetails);
        setShowGif(true);
        setTimeout(() => setShowGif(false), 1600); // Hide gif after 3s
      }
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [state]);

  if (loading) {
    return <Preloader />;
  }

  if (!order) {
    return (
      <div className="oc-container">
        <h1 className="oc-error-heading">No Order Found</h1>
        <p className="oc-text-muted">Please place an order first.</p>
        <Link to="/" className="oc-action-btn oc-home-btn">
          <i className="bi bi-house oc-btn-icon"></i> Back to Home
        </Link>
      </div>
    );
  }

  return (
    <div className="oc-container">
      {/* ✅ Checked GIF Overlay Only When Order is Valid */}
      {showGif && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(7, 7, 7, 0.82)',
            zIndex: 9999,
          }}
        >
          <img src={checked} alt="Order Successful" style={{ width: '180px' }} />
        </div>
      )}

      <h1 className="oc-heading">
        <i className="bi bi-check-circle-fill oc-success-icon"></i> Order Placed!
      </h1>
      <p className="oc-subheading">
        Thank you! Your order has been placed and will be delivered soon.
      </p>

      <div className="oc-section">
        <h2 className="oc-section-heading">Order Summary</h2>
        <div className="oc-cart-items">
          {order.items.map((item) => (
            <div key={`${item.productId}-${item.weight}`} className="oc-cart-item">
              <img
                src={item.image || '/placeholder-image.png'}
                alt={item.name || 'Product'}
                className="oc-item-image"
                onError={(e) => {
                  e.target.src = '/placeholder-image.png';
                }}
              />
              <div className="oc-item-details">
                <p className="oc-item-name">{item.name || 'N/A'}</p>
                <p className="oc-item-quantity">
                  Qty: {item.quantity || 1}, Weight: {item.weight || 'N/A'}
                </p>
                <p className="oc-item-price">
                  ₹{((item.price || 0) * (item.quantity || 1)).toFixed(2)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="oc-order-total">
          <span>Total Price:</span>
          <span className="oc-total-amount">
            ₹{(order.totalPrice || 0).toFixed(2)}
          </span>
        </div>

        <div className="oc-order-details">
          <p>
            <strong>Delivery Address:</strong> {order.deliveryDetails?.name || ''},{' '}
            {order.deliveryDetails?.address || ''}, {order.deliveryDetails?.city || ''},{' '}
            {order.deliveryDetails?.state || ''} - {order.deliveryDetails?.pincode || ''}
          </p>
          <p>
            <strong>Mobile:</strong> {order.deliveryDetails?.mobile || ''}
          </p>
        </div>
      </div>

      <div className="oc-action-buttons">
     
        <Link to="/my-orders" className="oc-action-btn oc-track-btn">
        View My Orders   
        </Link>
           <Link to="/" className="oc-action-btn oc-shop-btn">
         <span><i className='bi bi-arrow-left'></i>  Continue Shopping  </span>  
        </Link>
      </div>
    </div>
  );
};

export default OrderConfirmation;
